import React from "react";
import { Thumbnail } from "@culturehq/components";

import { ProfileLink } from "app/links";

import styles from "./styles.module.scss";

const ConnectionUser = ({ children, user }) => (
  <div className={[styles.receiver, "clearfix"].join(" ")}>
    <div className="Connection">
      <Thumbnail
        className={styles["receiver--img"]}
        image={user.avatar.thumbUrl}
      />
      <div>
        <ProfileLink user={user} />
        <br />
        {user.title}
      </div>
    </div>
    {children}
  </div>
);

export default ConnectionUser;
